import * as React from 'react';
import { DateRange } from 'react-date-range';
import PropTypes from 'prop-types';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { UilSchedule } from '@iconscout/react-unicons';
import moment from 'moment';
import { Button } from '../atoms';

function InputDateRange(props) {
  const { value, name, onChange, variant, theme, type, onChangeDateCostum, position } = props;
  const [isShowed, setIsShowed] = React.useState(false);

  React.useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  const refDate = React.useRef(null);

  const handleClickOutside = (event) => {
    if (refDate && !refDate.current.contains(event.target)) {
      setIsShowed(false);
    }
  };

  const check = (focus) => {
    focus.indexOf(1) < 0 && setIsShowed(false);
  };

  const displayDate = `${value?.startDate ? moment(value?.startDate).format('DD/MM/YYYY') : ''}${
    value?.endDate ? ' - ' + moment(value?.endDate).format('DD/MM/YYYY') : ''
  }`;

  return (
    <div className={`${position} z-40`}>
      <div ref={refDate} className={['calender-range input-date flex relative', props.outerClassName].join(' ')}>
        <Button
          variant={variant}
          theme={theme}
          content="icon-infront"
          icon={<UilSchedule size="18" />}
          action={() => setIsShowed(!isShowed)}
          className="w-full whitespace-nowrap"
        >
          {displayDate || 'Select date'}
        </Button>
        {isShowed && (
          <div className={`date-range-wrapper absolute top-12 ${type === 'custom right' && 'flex items-start'}`}>
            <DateRange
              name={name}
              editableDateInputs={true}
              onChange={onChange}
              moveRangeOnFirstSelection={false}
              onRangeFocusChange={check}
              ranges={[value]}
              maxDate={new Date()}
            />

            {type === 'custom right' && (
              <ul
                className="flex flex-col justify-between bg-neutral-light py-5 px-4 border-l border-gray-culture"
                style={{
                  height: '462px',
                }}
              >
                <li>
                  <Button
                    className="w-full"
                    variant="secondary"
                    theme="gray-spain"
                    action={() => onChangeDateCostum(moment().toDate(), moment().toDate())}
                  >
                    Today
                  </Button>
                </li>
                <li>
                  <Button
                    className="w-full"
                    variant="secondary"
                    theme="gray-spain"
                    action={() => onChangeDateCostum(moment().add(-1, 'day').toDate(), moment().add(-1, 'day').toDate())}
                  >
                    Yesterday
                  </Button>
                </li>
                <li>
                  <Button
                    className="w-full whitespace-nowrap"
                    variant="secondary"
                    theme="gray-spain"
                    action={() => onChangeDateCostum(moment().startOf('week').toDate(), moment().endOf('week').toDate())}
                  >
                    This week
                  </Button>
                </li>
                <li>
                  <Button
                    className="w-full whitespace-nowrap"
                    variant="secondary"
                    theme="gray-spain"
                    action={() =>
                      onChangeDateCostum(
                        moment().add(-1, 'week').startOf('week').toDate(),
                        moment().add(-1, 'week').endOf('week').toDate()
                      )
                    }
                  >
                    Last week
                  </Button>
                </li>
                <li>
                  <Button
                    className="w-full whitespace-nowrap"
                    variant="secondary"
                    theme="gray-spain"
                    action={() => onChangeDateCostum(moment().startOf('month').toDate(), moment().endOf('month').toDate())}
                  >
                    This month
                  </Button>
                </li>
                <li>
                  <Button
                    className="w-full whitespace-nowrap"
                    variant="secondary"
                    theme="gray-spain"
                    action={() =>
                      onChangeDateCostum(
                        moment().add(-1, 'month').startOf('month').toDate(),
                        moment().add(-1, 'month').endOf('month').toDate()
                      )
                    }
                  >
                    Last month
                  </Button>
                </li>
                <li>
                  <Button
                    className="w-full whitespace-nowrap"
                    variant="secondary"
                    theme="gray-spain"
                    action={() => onChangeDateCostum(moment().startOf('year').toDate(), moment().endOf('year').toDate())}
                  >
                    This year
                  </Button>
                </li>
                <li>
                  <Button
                    className="w-full whitespace-nowrap"
                    variant="secondary"
                    theme="gray-spain"
                    action={() =>
                      onChangeDateCostum(
                        moment().add(-1, 'year').startOf('year').toDate(),
                        moment().add(-1, 'year').endOf('year').toDate()
                      )
                    }
                  >
                    Last year
                  </Button>
                </li>
              </ul>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

InputDateRange.propTypes = {
  variant: PropTypes.string,
  value: PropTypes.object,
  theme: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  outerClassName: PropTypes.string,
};

InputDateRange.defaultProps = {
  position: 'items-center',
  variant: 'secondary',
};

export default InputDateRange;
